import { useState } from 'react'
import { mutate } from 'swr'
import { Update_Demo_School_Class } from '@graphql/mutations'
import { Books_Listing, DemoResources } from '@graphql/queries'
import { useApi } from '@hooks/useApi'
import { useCurrentUser } from '@hooks/useCurrentUser'

const useUpdateDemoSchoolClass = () => {
  const [isPosting, setIsPosting] = useState(false)
  const { currentUser } = useCurrentUser()
  const { postMutation } = useApi()

  const post = async (data, successMessage, errorMessage) => {
    setIsPosting(true)

    const res = await postMutation(
      { input: data },
      Update_Demo_School_Class,
      successMessage ? successMessage : 'Elev tillagd.',
      errorMessage
        ? errorMessage
        : 'Nåt gick fel när eleven skulle läggas till.',
      async () => {
        await mutate([DemoResources, { id: currentUser.id, connected: true }])
        await mutate([DemoResources, { id: currentUser.id, connected: false }])
        await mutate(Books_Listing)
      }
    )

    setIsPosting(false)
    return res
  }

  return {
    post,
    isPosting,
  }
}

export { useUpdateDemoSchoolClass }
